import { useOnlineStatus } from "@client/hooks/useOnlineStatus";

/**
 * One line under the top bar for as long as the browser reports no network.
 *
 * It exists so that the next failure is not a surprise. Without it, an offline
 * user clicks Save, waits, gets "Could not reach the server", and reasonably
 * concludes the app is broken; with it, they already know why, and that their
 * work is not lost.
 *
 * Amber, not red: being offline is a condition, not an error, and the app keeps
 * working — the editor is entirely local until it saves.
 */
export function OfflineBanner() {
  const online = useOnlineStatus();
  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="border-b px-4 py-2 text-center text-xs font-semibold text-ink"
      style={{ borderColor: "var(--chart-warn)", background: "var(--chip-bg)" }}
    >
      <span aria-hidden="true">⚠ </span>
      You are offline. Nothing can be saved or loaded until the connection returns — edits stay on
      this device in the meantime.
    </div>
  );
}
